import { useState } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import FormTextField from '@components/FormTextField/FormTextField';
import HtmlContent from '@components/HtmlContent/HtmlContent';

import { PreviewFieldProps } from './PreviewField.inteface';

import './style.scss';

export const PreviewField = ({ label, name, value }: PreviewFieldProps) => {
  const { t } = useTranslation();
  const [showPreview, setShowPreview] = useState(false);

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };

  return (
    <div className="preview-field__fieldset">
      <Field component={FormTextField} label={label} name={name} multiline />

      {showPreview ? (
        <>
          <HtmlContent className="preview-field__preview">{value}</HtmlContent>
          <Button variant="outlined" onClick={togglePreview}>
            Close preview
          </Button>
        </>
      ) : (
        <Button variant="outlined" disabled={showPreview || !value} onClick={togglePreview}>
          {t('admin.preview')}
        </Button>
      )}
    </div>
  );
};
